import React, { useRef, useEffect } from 'react'

// don't remove this import
import _LiveEncoderListing from '@invintusmedia/live-encoder-listing'

const SourceMultiViewerComponent = (props) => {
  const { clientID } = props
  const ref = useRef(null)
  const htmlEl = document.documentElement

  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      console.log('Live encoder listing', window.InvintusLiveEncoderListing)
    }
    if (ref.current) {
      htmlEl.style.fontSize = 'initial'
      window.InvintusLiveEncoderListing.launch({ clientID })
    }
    return () => {
      // reset html font-size on unmount
      htmlEl.style.fontSize = '10px'
    }
  }, [ref, window.InvintusLiveEncoderListing])
  return (
    <div id='liveEncoderListing' className='inv-liveEncoderListing' ref={ref}>
      {/* mounted here */}
    </div>
  )
}

const SourceMultiViewerRoute = (api, socket, opts, match) => {
  return () => <SourceMultiViewerComponent clientID={opts.credentials.clientID} />
}

export default SourceMultiViewerRoute
